import { render } from "./QuestionNestedDraggableQuestionComponent.vue?vue&type=template&id=5cb00471"
import script from "./QuestionNestedDraggableQuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionNestedDraggableQuestionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__